import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { hasConsentSignatureAnswer } from 'src/app/core/api/consent-form.util';

/** Requires a drawn, typed, or uploaded signature payload on the control value. */
export const signatureRequiredValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  return hasConsentSignatureAnswer(control.value) ? null : { required: true };
};
